import { inject, observer } from "mobx-react";
import * as React from "react";
import { Text, Grid, GridColumn, Separator, Notice, Tabs, TabsItem } from "telia-front-react";
import AmountFieldComponent from "./AmountFieldComponent.mjs";
import { BanklinksComponent } from "./banklink/BanklinksComponent.mjs";
import CardComponent from "./card/CardComponent.mjs";
import PaymentFinalized from "./PaymentFinalized.mjs";
class PaymentTemplate extends React.Component {
  render() {
    const { finalizePaymentProps, headless, paymentMethods } = this.props.paymentProps;
    const { paymentHasFinalStatus } = this.props.paymentStore;
    if (paymentHasFinalStatus) {
      return /* @__PURE__ */ React.createElement(PaymentFinalized, { finalizePaymentProps });
    }
    if (headless && paymentMethods.length === 1) {
      return this.renderPaymentMethod(paymentMethods[0]);
    }
    return /* @__PURE__ */ React.createElement(React.Fragment, null, !headless && this.renderHeadings(), this.renderTabsWithPaymentMethods());
  }
  renderHeadings() {
    const { amountFieldState } = this.props.paymentStore;
    const { headingLabel, editingHeadingLabel } = this.props.paymentProps;
    const { translate } = this.props.translateStore;
    const headingText = amountFieldState === "EDITING" ? editingHeadingLabel || translate("payment.edit-payment") : headingLabel || translate("payment.make-payment");
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Text, { className: "text-center" }, /* @__PURE__ */ React.createElement(Grid, { align: ["center-xs"] }, /* @__PURE__ */ React.createElement(GridColumn, null, /* @__PURE__ */ React.createElement("h1", { id: "payment-heading", className: "h3" }, headingText), this.paymentProcessingDelayedNotice(), this.paymentTemplateNotice(), /* @__PURE__ */ React.createElement(AmountFieldComponent, { paymentProps: this.props.paymentProps })))), /* @__PURE__ */ React.createElement(Separator, { spacing: "xxsmall", color: "invisible" }));
  }
  paymentProcessingDelayedNotice() {
    const { translate } = this.props.translateStore;
    if (this.props.paymentProps.brand === "SUPER") {
      return;
    }
    const { payload } = this.props.settingsStore.config;
    if (!payload?.paymentProcessingDelayed) {
      return;
    }
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Separator, { spacing: "xxsmall", color: "invisible" }), /* @__PURE__ */ React.createElement(Notice, { type: "attention" }, translate("payment.warning.payment-processing-delayed")));
  }
  paymentTemplateNotice() {
    const { noticeProps } = this.props;
    if (!noticeProps?.children) {
      return;
    }
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Separator, { spacing: "xxsmall", color: "invisible" }), /* @__PURE__ */ React.createElement(Notice, { id: "payment-template-notice", ...noticeProps }, noticeProps.children));
  }
  renderTabsWithPaymentMethods() {
    const { translate } = this.props.translateStore;
    const teliaTabsProps = this.props.paymentProps.brand === "TELIA" ? {
      size: "medium"
    } : void 0;
    const { paymentMethods, currentTab } = this.props.tabStore;
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        style: this.props.paymentStore.amountFieldState === "EDITING" ? { display: "none" } : void 0,
        id: "visibility-control"
      },
      /* @__PURE__ */ React.createElement("h3", { id: "payment-methods", style: { display: "none" } }, translate("payment.payment-methods")),
      /* @__PURE__ */ React.createElement(
        Tabs,
        {
          currentTab,
          align: "center",
          border: "top",
          onTabChange: (_prevTab, nextTab) => this.handleTabChange(nextTab),
          "aria-labelledby": "payment-methods",
          ...teliaTabsProps
        },
        paymentMethods.filter((method) => Object.keys(this.paymentTabs).includes(method)).map((it) => this.renderTab(it))
      )
    );
  }
  renderTab(paymentMethod) {
    const { translate } = this.props.translateStore;
    const { id, label } = this.paymentTabs[paymentMethod];
    return /* @__PURE__ */ React.createElement(TabsItem, { label: translate(label), id, key: id }, this.renderPaymentMethod(paymentMethod));
  }
  renderPaymentMethod(paymentMethod) {
    const { paymentProps } = this.props;
    switch (paymentMethod) {
      case "banklinks":
        return /* @__PURE__ */ React.createElement(BanklinksComponent, { paymentProps });
      case "card":
        return /* @__PURE__ */ React.createElement(
          CardComponent,
          {
            paymentProps,
            isAmountEditing: this.props.paymentStore.amountFieldState === "EDITING"
          }
        );
    }
  }
  handleTabChange(nextTab) {
    this.props.tabStore.setCurrentTab(nextTab);
    const { onTabChange } = this.props.paymentProps;
    if (onTabChange) {
      switch (nextTab) {
        case "payment-banklink-tab":
          onTabChange("banklink");
          break;
        case "payment-card-tab":
          onTabChange("card");
          break;
      }
    }
  }
  paymentTabs = {
    banklinks: {
      id: "payment-banklink-tab",
      label: "payment.banklink-tab"
    },
    card: {
      id: "payment-card-tab",
      label: "payment.card-tab"
    }
  };
}
const PaymentTemplate$1 = inject("translateStore", "paymentStore", "tabStore", "settingsStore")(observer(PaymentTemplate));
export {
  PaymentTemplate$1 as default
};
